import MessageText from "./MessageText";

const MessageVideo = ({message}) => {
    return message.video_url && <><div className="video-file-type">
            <video controls>
                <source src={message.video_url}/>
                <a href={message.video_url} target='_blank' rel="noopener noreferrer"
                className='message-file'>
                <span
                    className="font-size-xlg pe-7s-video m-1 mr-2 text-decoration-none text-dark"/>
                    <span>{message.video_url}</span>
                </a>
            </video>
        </div>
        <MessageText text={message.text}/>
    </>
}

export default MessageVideo;